export default __webpack_public_path__ + "static/media/insta.d3ebd762.png";